import React from "react";

const TabSlider = ({
    className,
    options = [],
    selected,
    selectedClassname,
    notSelectedClassname,
    selectedStyle,
    notSelectedStyle,
}) => {
    const borderBottom = selectedStyle?.color;
    const borderBottomNotSelected = borderBottom?.includes("rgb")
        ? borderBottom.replace(/[^,]*?(?=\))/, "0.2")
        : `${borderBottom}22`;

    return (
        <div id="tab-slider" className={`${className} flex overflow-y-scroll `} style={{ scrollbarWidth: "none" }}>
            {options.map((option, index) => (
                <div
                    className={`relative h-full flex-1 flex justify-center items-center ${
                        index == 0 ? "pl-2" : index == options.length - 1 ? "pr-2" : ""
                    }`}
                    key={`tab-option-${index} h-full`}
                    style={{
                        minWidth: "fit-content",
                        backgroundColor:
                            selected == option.value
                                ? selectedStyle?.backgroundColor
                                : notSelectedStyle?.backgroundColor,
                    }}
                >
                    <button
                        className={`relative border-b-2 px-4 w-full ${
                            selected == option.value ? selectedClassname : notSelectedClassname
                        }`}
                        style={{
                            ...(selected == option.value
                                ? { ...selectedStyle, backgroundColor: "none", borderColor: borderBottom }
                                : {
                                      ...notSelectedStyle,
                                      backgroundColor: "none",
                                      borderColor: borderBottomNotSelected,
                                  }),
                        }}
                        onClick={() => {
                            option.onClick(option.value);
                        }}
                    >
                        {option.label}
                    </button>
                </div>
            ))}
        </div>
    );
};

export default TabSlider;
